// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__20fDa","alertIcon":"ConfirmModal_alertIcon__2WJjv"};